import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`


*,
*::after,
*::before{
  margin: 0 ;
  padding: 0;
  box-sizing: inherit ;
}

html {
  box-sizing: border-box !important;;
  font-size: 62.5% !important; // 10px/16px = 62.5% -> 1rem = 10px
}


body {
  background: ${({ theme }) => theme.colors.neutral.neutral5};
  font-family: ${({ theme }) => theme.font.family};
  -webkit-font-smoothing: antialiased;
  margin: 0;
  padding: 0;
}


button {
  font-family: ${({ theme }) => theme.font.family};
  cursor: pointer;
}

.hideModal {
  display: none;
}

.showModal {
  display: block;
}

[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}
`;
